import { render, staticRenderFns } from "./PayBank.vue?vue&type=template&id=4bafefe6&scoped=true&"
import script from "./PayBank.vue?vue&type=script&lang=js&"
export * from "./PayBank.vue?vue&type=script&lang=js&"
import style0 from "./PayBank.vue?vue&type=style&index=0&id=4bafefe6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bafefe6",
  null
  
)

export default component.exports